// src/pages/admin/AdminLayout.tsx
import React from 'react';
import { NavLink, Outlet, useNavigate } from 'react-router-dom';
import { useAuth } from 'src/features/auth/AuthContext';

const linkBase = 'px-3 py-1.5 text-xs rounded-full border transition-colors';
const linkActive = 'bg-sky-600 text-white border-sky-600';
const linkInactive = 'bg-white text-gray-700 border-gray-200 hover:bg-gray-50';

const AdminLayout: React.FC = () => {
    const { me, logout } = useAuth();
    const nav = useNavigate();

    const handleLogout = async () => {
        await logout();
        nav('/login?logged_out=1', { replace: true });
    };

    return (
        <div className="p-6 space-y-4">
            {/* 상단 헤더 */}
            <div className="flex items-center justify-between">
                <div>
                    <h1 className="text-xl font-bold text-gray-900">Service Admin</h1>
                    <p className="text-xs text-gray-500 mt-1">테넌트 정보, 사용자, 역할 및 권한을 관리합니다.</p>
                </div>
                <div className="flex items-center gap-3 text-xs">
                    {!me?.isGuestOnlyUser && (
                        <button
                            type="button"
                            onClick={() => nav('/account/security')}
                            className="px-3 py-1.5 rounded-full border border-gray-300 text-xs text-gray-700 hover:bg-gray-50"
                        >
                            비밀번호 변경
                        </button>
                    )}
                    {me && (
                        <div className="text-right">
                            <div className="font-medium text-gray-800">{me.name || me.email}</div>
                            <div className="text-[11px] text-gray-500">{me.email}</div>
                        </div>
                    )}
                    <button
                        type="button"
                        onClick={handleLogout}
                        className="px-3 py-1.5 rounded-full border border-gray-300 text-xs text-gray-700 hover:bg-gray-50"
                    >
                        로그아웃
                    </button>
                </div>
            </div>

            {/* 탭 네비게이션 */}
            <div className="flex flex-wrap items-center gap-2">
                <NavLink
                    to="overview"
                    end
                    className={({ isActive }) => `${linkBase} ${isActive ? linkActive : linkInactive}`}
                >
                    Overview
                </NavLink>

                <NavLink
                    to="companies"
                    className={({ isActive }) => `${linkBase} ${isActive ? linkActive : linkInactive}`}
                >
                    Companies
                </NavLink>

                <NavLink to="users" className={({ isActive }) => `${linkBase} ${isActive ? linkActive : linkInactive}`}>
                    Users
                </NavLink>

                <NavLink to="roles" className={({ isActive }) => `${linkBase} ${isActive ? linkActive : linkInactive}`}>
                    Roles
                </NavLink>

                <NavLink
                    to="permissions"
                    className={({ isActive }) => `${linkBase} ${isActive ? linkActive : linkInactive}`}
                >
                    Permissions
                </NavLink>
            </div>

            {/* 내용 카드 */}
            <div className="rounded-2xl border bg-white shadow-sm">
                <Outlet />
            </div>
        </div>
    );
};

export default AdminLayout;
